var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderBadge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 14.4C10.0902 14.4 8.2589 13.6414 6.90864 12.2912C5.55837 10.9409 4.7998 9.10956 4.7998 7.2C4.7998 5.29044 5.55837 3.45909 6.90864 2.10883C8.2589 0.758569 10.0902 0 11.9998 0C13.9094 0 15.7407 0.758569 17.091 2.10883C18.4412 3.45909 19.1998 5.29044 19.1998 7.2C19.1998 9.10956 18.4412 10.9409 17.091 12.2912C15.7407 13.6414 13.9094 14.4 11.9998 14.4ZM11.9998 10.8C12.9546 10.8 13.8703 10.4207 14.5454 9.74559C15.2205 9.07045 15.5998 8.15478 15.5998 7.2C15.5998 6.24522 15.2205 5.32955 14.5454 4.65442C13.8703 3.97929 12.9546 3.6 11.9998 3.6C11.045 3.6 10.1294 3.97929 9.45422 4.65442C8.77909 5.32955 8.3998 6.24522 8.3998 7.2C8.3998 8.15478 8.77909 9.07045 9.45422 9.74559C10.1294 10.4207 11.045 10.8 11.9998 10.8ZM16.7998 14.1V24L11.9998 19.2L7.1998 24V14.1C8.60636 15.0857 10.2823 15.6144 11.9998 15.6144C13.7173 15.6144 15.3933 15.0857 16.7998 14.1Z",
    fill: "#16A9B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBadge);
export default __webpack_public_path__ + "static/media/header-badge.c1249a425f117bdf7c0743ec4e1fafb7.svg";
export { ForwardRef as ReactComponent };